/* eslint-disable no-nested-ternary */
import { useMutation, useQuery } from "@apollo/client";
import prepareComponent from "@bluframe/grapple/prepareComponent";
import useToggle from "@bluframe/grapple/useToggle";
import onEmailsError from "components/Emails/onEmailsError";
import { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Item from "./Item";
const DEFAULT_ERRORS = {};
const usePrepareComponent = ({ getQuery, getQueryDataName, itemName, updateMutation }) => {
    const [isEditing, toggleIsEditing] = useToggle();
    const history = useHistory();
    const params = useParams();
    const [errors, setErrors] = useState(DEFAULT_ERRORS);
    const { data, loading } = useQuery(getQuery, {
        variables: {
            id: params.id
        }
    });
    const [updateEmailsItem, { loading: isSaveLoading }] = useMutation(updateMutation, {
        refetchQueries: [{ query: getQuery, variables: { id: params.id } }]
    });
    const onCancel = () => {
        history.push(`/emails/${itemName}s`);
    };
    const onEdit = () => {
        toggleIsEditing();
    };
    const onSave = (itemUpdate) => {
        const updateInputName = itemName === "footer"
            ? "emailsFooterUpdateInput"
            : itemName === "heading"
                ? "emailsHeadingUpdateInput"
                : "emailsTemplateUpdateInput";
        updateEmailsItem({
            onCompleted: () => {
                toggleIsEditing();
            },
            onError: onEmailsError(setErrors),
            variables: {
                id: params.id,
                [updateInputName]: {
                    footerId: itemUpdate.footerId,
                    headingId: itemUpdate.headingId,
                    html: itemUpdate.html,
                    identifier: itemUpdate.identifier,
                    name: itemUpdate.name,
                    placeholders: itemUpdate.placeholders,
                    subject: itemUpdate.subject
                }
            }
        });
    };
    return {
        errors,
        isEditing,
        isSaveLoading,
        isTemplate: itemName === "template",
        item: data?.[getQueryDataName],
        loading,
        onCancel,
        onEdit,
        onSave
    };
};
export default prepareComponent(usePrepareComponent)(Item);
